const key = 'reports';

export const REPORTS_HISTORY_PAGINATION_LIMIT = 10;

export const SET_REPORTS_LIST = `${key}/SET_REPORTS_LIST`;
export const SET_REPORTS_LIST_OPEN_VALUE = `${key}/SET_REPORTS_LIST_OPEN_VALUE`;
export const SET_REPORTS_LIST_FILTERS = `${key}/SET_REPORTS_LIST_FILTERS`;
export const SET_REPORTS_LIST_FETCH_STATUS = `${key}/SET_REPORTS_FETCH_STATUS`;

export const SET_HISTORY = `${key}/SET_HISTORY`;
export const SET_HISTORY_PAGE = `${key}/SET_HISTORY_PAGE`;
export const SET_HISTORY_FETCH_STATUS = `${key}/SET_HISTORY_FETCH_STATUS`;

export const SET_HISTORY_MANAGE_MODE_IS_ON = `${key}/SET_HISTORY_MANAGE_MODE_IS_ON`;
export const SET_HISTORY_MANAGE_MODE_SELECTED_ENTRIES = `${key}/SET_HISTORY_MANAGE_MODE_SELECTED_ENTRIES`;



// WEBPACK FOOTER //
// ./app/web/src/container/ReportsPage/constants.js